import commonJsModule from "ensure-start"

export default commonJsModule.default